module.exports = __webpack_public_path__ + "static/media/generic_record.222f2d25.jpg";